import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { BaseChip } from './base';

export function LikeChip(props) {
    return <BaseChip 
    {...props} 
    active={props.liked}
    icon={props.liked ? <FavoriteIcon color="error" /> : <FavoriteBorderIcon />} 
  />
}
